export default __webpack_public_path__ + "static/media/Shikha-ji.5214d083.jpg";